/**
 * Environment configuration.
 *
 * The PocketBase URL is injected at build time by Vite from
 * VITE_POCKETBASE_URL, which netlify.toml sets per deploy context (production,
 * the qa and dev branches, and pull-request previews). Locally it comes from
 * .env.local -- see .env.example.
 *
 * This replaced an earlier scheme that guessed the environment from
 * window.location.hostname. Build-time injection is safer: there is no
 * client-side pattern match that a new hostname could accidentally satisfy,
 * and a preview build physically cannot hold the production URL.
 */

const rawUrl = import.meta.env.VITE_POCKETBASE_URL ?? '';

/** Base URL with any trailing slash removed, so path concatenation is safe. */
export const POCKETBASE_URL = rawUrl.trim().replace(/\/+$/, '');

export const APP_ENV = import.meta.env.VITE_APP_ENV ?? 'local';

/**
 * When no URL is configured the app runs local-only: the account bar is
 * hidden and nothing is ever sent anywhere. That is a deliberate safe
 * default rather than a broken state -- it is also exactly the app's
 * original behaviour.
 */
export const PB_CONFIGURED = POCKETBASE_URL.length > 0;

if (!PB_CONFIGURED) {
  console.info(
    `[config] No VITE_POCKETBASE_URL set for "${APP_ENV}". ` +
      'Running in local-only mode; cloud sync is disabled.',
  );
}
